import React, { useMemo } from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { ReactComponent as RenovationHouse } from 'assets/images/quick-calculator/renovation-house.svg';
import Button from 'components/common/Button';
import { ArrowBack, ArrowForward } from 'assets/icons';
import { get } from 'lodash';
import s from './EnergyReductionAndGhgEquivalents.module.scss';
import EnergyGhgEquivalents from './EnergyGhgEquivalents';
import EnergyReductionItems from './EnergyReductionItems/EnergyReductionItems';

const EnergyReductionAndGhgEquivalents = ({ co2Calculations, t, nextStep, previousStep }) => {
  const { result } = co2Calculations.co2_emissions_before;
  const equivalentValues = useMemo(
    () => ({
      energyGhgEquivalentPlane: get(result, 'energy_ghg_equivalent_plane', 0),
      energyGhgEquivalentCar: get(result, 'energy_ghg_equivalent_car', 0),
      energyGhgEquivalentTrees: get(result, 'energy_ghg_equivalent_trees', 0),
    }),
    [result],
  );

  return (
    <>
      <Row className="mb-4">
        <Col lg={6}>
          <EnergyReductionItems {...{ co2Calculations, t }} />
        </Col>
        <Col lg={6}>
          <h3 className="mt-0">
            {t({ id: 'renovation_house_wizard.potential_energy_balance.redevelopment_house_label' })}
          </h3>
          <div className={s.buttonsWrapper}>
            <Button onClick={previousStep} startIcon={<ArrowBack />}>
              {t({ id: 'app.back' })}
            </Button>
            <Button onClick={nextStep} color="secondary" endIcon={<ArrowForward />}>
              {t({ id: 'renovation_house_wizard.improve_house_btn_label' })}
            </Button>
          </div>
          <div>
            <RenovationHouse title={t({ id: 'alt_text.renovation_house.renovation_house_img' })} />
          </div>
        </Col>
      </Row>
      <EnergyGhgEquivalents {...{ equivalentValues }} />
    </>
  );
};

export default EnergyReductionAndGhgEquivalents;
